<template>
  <v-card class="item" v-bind="link" flat tile>
    <img class="d-block item-img" :src="image" width="100%" height="100%" />

    <div
      class="
        d-flex
        flex-column
        justify-end
        white--text
        text-body-1 text-sm-h6 text-md-h5 text-lg-h4 text-uppercase
        pa-2 pa-sm-5 pa-md-6 pa-lg-7
        item-caption
      "
    >
      <div class="font-weight-regular">
        {{ title }}
      </div>
      <div class="font-weight-bold">
        {{ subtitle }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  aspect-ratio: 360 / 210;

  &-img {
    object-fit: cover;
  }

  &-caption {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
